import { useCohortEditable } from '@verantos-dev/app-state-cohort-builder';
import {
  closeResearchAssistant,
  openResearchAssistant,
  toggleResearchAssistant,
  useAllowMessageSubmit,
  useIsResearchAssistantEnabled,
  useIsResearchAssistantOpen,
  useResearchAssistantAvailability,
} from '@verantos-dev/app-state-research-assistant';

const useResearchAssistantViewState = () => {
  const isRAOpen = useIsResearchAssistantOpen();
  const isRAEnabled = useIsResearchAssistantEnabled();
  const allowMessageSubmit = useAllowMessageSubmit();
  const { isEditable } = useCohortEditable();

  return {
    isRAOpen,
    isRAEnabled,
    allowMessageSubmit,
    isOwner: isEditable,
  };
};

/**
 * Custom hook for global Research Assistant state and actions
 *
 * Centralizes all the Research Assistant related functionality:
 * - State: isOpen, isEnabled, isAvailable
 * - Actions: open, close, toggle
 * - Availability checks
 */
export const useGlobalResearchAssistant = () => {
  const { isRAOpen, isRAEnabled, allowMessageSubmit, isOwner } = useResearchAssistantViewState();

  useResearchAssistantAvailability();

  return {
    isRAOpen,
    isRAEnabled,
    allowMessageSubmit,
    isOwner,

    openRA: openResearchAssistant,
    closeRA: closeResearchAssistant,
    toggleRA: toggleResearchAssistant,
  };
};
